import jQuery from 'jquery';
import Swal from 'sweetalert2';
import "@fortawesome/fontawesome-free";
import "bootstrap";

window.$ = window.jQuery = jQuery;
window.Swal = Swal;
